module.exports = __webpack_public_path__ + "img/Default-caurse_hot.dde79b84.png";